<template>
  <!-- Ya no se renderiza nada visible: el vale ya no se genera como PDF en
       el navegador, se manda directo al agente local para imprimirse. -->
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import axiosAdelaService from '@/axios/axiosAdelaService'

const PRINT_AGENT_URL = 'http://127.0.0.1:39120'

export default {
  props: ['folio', 'enterprise', 'print', 'type'],
  data () {
    return {
      footer: [],
      ultimaVenta: [],
      detalles: []
    }
  },
  watch: {
    async print () {
      await this.getFooterTicket()
      if (this.type === 'AJUSTE' || this.type === 'ABONO') {
        this.getAbonoDetail(this.folio)
      } else {
        this.getDevolutionDetail(this.folio)
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    // Variante: vale por abono/ajuste — una sola línea de monto
    async getAbonoDetail (invoice) {
      this.ultimaVenta = []
      const request = {
        folio: invoice,
        enterprise_id: this.user.enterprise_id
      }
      const response = await axiosAdelaService.post('/getDetailVale', request)
      if (response.status === 200) {
        this.ultimaVenta = response.data.rows
        this.detalles = response.data.rows // mismo objeto, igual que en el original
        this.ultimaVenta.create_at = moment(this.ultimaVenta.create_at).format('YYYY-MM-DD')

        await this.imprimirVale()
      }
    },

    // Variante: vale por devolución de productos — lista de items
    async getDevolutionDetail (invoice) {
      this.ultimaVenta = []
      const request = {
        folio: invoice,
        id_empresa: this.user.enterprise_id
      }
      const response = await axiosAdelaService.post('/getDetailDevolutionTicket', request)
      if (response.status === 200) {
        this.ultimaVenta = response.data.rows
        this.detalles = response.data.detail
        this.detalles.create_at = moment(this.detalles.create_at).format('YYYY-MM-DD')

        await this.imprimirVale()
      }
    },

    async imprimirVale () {
      const esAbono = this.type === 'ABONO' || this.type === 'AJUSTE'

      const payload = {
        tipo: 'vale',
        tienda: this.enterprise,
        folio: this.detalles.folio,
        codigo: this.detalles.barcode,
        cliente: `${this.detalles.client_id != null ? this.detalles.client_id : ''} ${this.detalles.fullName || ''}`.trim(),
        // items O abono, nunca los dos — así distingue el agente qué variante imprimir
        ...(esAbono
          ? { abono: this.ultimaVenta.amount }
          : {
            items: this.ultimaVenta.map((r) => ({
              descripcion: r.producto,
              precio: r.precio,
              descuentoPct: r.porcentaje_descuento,
              total: r.venta
            }))
          }),
        usos: (this.ultimaVenta.used || []).map((v) => ({
          concepto: `VENTA FOLIO ${v.invoice}`,
          monto: v.amount
        })),
        totalVale: esAbono ? this.ultimaVenta.amount : this.detalles.amount,
        totalUtilizado: this.detalles.amount_used,
        totalActual: this.detalles.disponible,
        fechaCreacion: this.detalles.create_at,
        fechaActualizacion: this.detalles.update_at,
        telefonos: (this.footer.phones || []).map((p) => p.phone),
        nota: this.footer.couponFooter
      }

      try {
        const resp = await fetch(`${PRINT_AGENT_URL}/print`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
        const data = await resp.json()
        if (!data.ok) {
          this.showError('Error al imprimir: ' + data.error)
        }
      } catch (e) {
        this.showError(
          'No se pudo conectar con el agente de impresión local. Verifica que esté abierto en esta computadora.'
        )
      }
    },

    async getFooterTicket () {
      const request = {
        enterprise_id: this.user.enterprise_id
      }
      const response = await axiosAdelaService.post('/getFooterTicket', request)
      if (response.status === 200) {
        this.footer = response.data
      }
    }
  }
}
</script>
